import React, { useEffect, Suspense } from "react";
import { Loading } from "@/layouts/loading";

export function LandingPage() {
  useEffect(() => {
    window.location.replace("https://lp.sysigreja.com");
  }, []);

  return (
    <Suspense fallback={<Loading />}>
    </Suspense>
  );
}
